import React, { useEffect } from "react";
import styles from "../assets/scss/pages.module.scss";
import Title from "components/title/Title";
import PaintingsDescriptionSection from "sections/paintingsPage/paintingsDescriptionSection/PaintingsDescriptionSection";
import PaintingsListSection from "sections/paintingsPage/paintingsListSection/PaintingsListSection";

const PaintingsPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.paintingsPageContainer}>
      <div className="container">
        <Title text={"Paintings"} bottomStrokeWidth={"55%"} />
        <PaintingsDescriptionSection />
        <PaintingsListSection />
      </div>
    </div>
  );
};

export default PaintingsPage;
